import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchVehicleAccountsSuccess,
  fetchVehicleAccountsFailure,
  createPaymentSuccess,
  createPaymentFailure,
  createPaidPaymentSuccess,
  createPaidPaymentFailure,
  UpdateTopaySuccess,
  UpdateTopayFailure,
  SendPdfSuccess,
  SendPdfFailure,
} from "../slices/VehicleAccountSlice";
import { StatusCodes } from "http-status-codes";
import { request } from "src/utils/api";
import {
  CREATE_PAID_PAYMENT,
  CREATE_PAYMENT_HISTORY,
  FETCH_TABLE_DATA,
  SEND_PDFY,
  UPDATET_TOPAY,
} from "../actions/vehicalaccountAction";
// import notification from "antd/es/notification";
import { notification, Button } from "antd";

export function* fetchVehicleAccountsSaga(
  action: any,
): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK)
      yield put(fetchVehicleAccountsSuccess(result.data));
    else {
      yield put(fetchVehicleAccountsFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchVehicleAccountsFailure(error.message));
  }
}

export function* createPaymentSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);

    if (result.status === StatusCodes.OK) {
      yield put(createPaymentSuccess(result.data));
      notification.success({
        message: "Add ToPay success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(createPaymentFailure(result.message));
      notification.error({
        message: "Add ToPay Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(
      createPaymentFailure(
        error?.response?.data?.message ||
          error.message ||
          "Something went wrong!",
      ),
    );
  }
}

export function* createPaidSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);

    if (result.status === StatusCodes.OK) {
      yield put(createPaidPaymentSuccess(result.data));
      notification.success({
        message: "Payment success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(createPaidPaymentFailure(result.message));
      notification.error({
        message: "Payment Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(
      createPaidPaymentFailure(
        error?.response?.data?.message ||
          error.message ||
          "Something went wrong!",
      ),
    );
  }
}

export function* UpdateTopaySaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);

    if (result.status === StatusCodes.OK) {
      yield put(UpdateTopaySuccess(result.toPayData));
    } else {
      yield put(UpdateTopayFailure(result.message));
    }
  } catch (error: any) {
    yield put(
      UpdateTopayFailure(
        error?.response?.data?.message ||
          error.message ||
          "Something went wrong!",
      ),
    );
  }
}

export function* SendPdfSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);

    if (result.status === StatusCodes.OK) {
      yield put(SendPdfSuccess(result));
      notification.success({
        message: "Message Sent success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(SendPdfFailure(result.message));
      notification.error({
        message: "Message Sent Failed",
        description:result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(
      SendPdfFailure(
        error?.response?.data?.message ||
          error.message ||
          "Something went wrong!",
      ),
    );
  }
}

export default function* vehicleAccountSaga() {
  yield all([
    takeLatest(FETCH_TABLE_DATA, fetchVehicleAccountsSaga),
    takeLatest(CREATE_PAYMENT_HISTORY, createPaymentSaga),
    takeLatest(CREATE_PAID_PAYMENT, createPaidSaga),
    takeLatest(UPDATET_TOPAY, UpdateTopaySaga),
    takeLatest(SEND_PDFY, SendPdfSaga),
  ]);
}
